import { Theme } from '../types';

export const theme: Theme = {
  colors: {
    primary: '#181a20',
    success: '#0fdf39',
    warning: '#f59e0b',
    error: '#ef4444',
    secondary: '#353641',
    background: {
      primary: '#0B0E11',
      secondary: '#1E2329',
      tertiary: '#2B3139',
      hover: '#353641',
      input: '#1E2329'
    },
    text: {
      primary: '#EAECEF',
      secondary: '#848E9C',
      tertiary: '#5E6673',
      placeholder: '#5E5D66',
      hover: '#01bce0'
    },
    border: {
      primary: '#2B3139',
      secondary: '#474D57',
      focus: '#0ECB81'
    },
    button: {
      primary: '#31313F',
      secondary: '#ffffff',
      hover: '#01bce0'
    },
    trading: {
      buy: '#0ECB81',
      sell: '#F6465D',
      long: '#0ECB81',
      short: '#F6465D',
      warning: '#FCD535',
      up: '#0ECB81',
      down: '#F6465D'
    }
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px'
  },
  fontSize: {
    xs: '10px',
    sm: '11px',
    base: '12px',
    md: '14px',
    lg: '16px',
    xl: '20px',
    xxl: '24px'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px'
  }
};